import { version } from '@interface-db/version';

export default version;
